import GenericBody from "../Componentes/GenericBody"
import NavBar from "../Componentes/NavBar"
import { useModal } from "../contexts/ModalContext"
import Content from "../Modulos/Desvios/Metas/Content"

const DesviosMetas = () => {

    const { openModal } = useModal();

    const abrirMenuLateral = () => {
        openModal("sidebarMetasDesvios");
    }

    return(
        <>
            <NavBar title="METAS DESVIOS" goBackOnePage setSideBar={abrirMenuLateral} />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    )
}

export default DesviosMetas;